/**
 * 仮ユーザ用画面のルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import TemporaryUserLogin from '../views/activate/TemporaryUserLogin.vue'
import RegistInformation from '../views/activate/RegistInformation.vue'
import RegistInformationComplete from '../views/activate/RegistInformationComplete.vue'
import TokenCheck from '../views/activate/TokenCheck.vue'
import TokenInvalid from '../views/activate/TokenInvalid.vue'
import RegistPassword from '../views/activate/RegistPassword.vue'
import ActivateComplete from '../views/activate/ActivateComplete.vue'

/**
 * 仮ユーザ用ページ群
 */
const temporaryUserRoutes: Array<RouteConfig> = [
  // ログイン
  {
    path: '/activate/login',
    name: 'ActivateLogin',
    component: TemporaryUserLogin,
  },
  // メールアドレス登録
  {
    path: '/activate/regist',
    name: 'ActivateRegist',
    component: RegistInformation,
  },
  // メールアドレス登録完了
  {
    path: '/activate/regist/complete',
    name: 'ActivateRegistComplete',
    component: RegistInformationComplete,
  },
  // 認証メールからの遷移先クッションページ
  {
    path: '/activate',
    name: 'ActivateToken',
    component: TokenCheck,
  },
  // トークン無効画面
  {
    path: '/activate/invalid',
    name: 'ActivateInvalid',
    component: TokenInvalid,
  },
  // パスワード登録
  {
    path: '/activate/password',
    name: 'ActivatePassword',
    component: RegistPassword,
  },
  // 有効化完了
  {
    path: '/activate/complete',
    name: 'ActivateComplete',
    component: ActivateComplete,
  },
]

export default temporaryUserRoutes
